import { Check, Copy03 } from "untitledui-js/react";
import { Pill } from "./Pill";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface CopyLabelProps {
  textCopy: string;
  children: React.ReactNode;
}

export const CopyLabel = ({ textCopy, children }: CopyLabelProps) => {
  const { t } = useTranslation();

  const [textCopied, setTextCopied] = useState(false);

  useEffect(() => {
    if (textCopied) {
      const timer = setTimeout(() => setTextCopied(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [textCopied]);

  return (
    <Pill
      variant={textCopied ? "success" : "default"}
      icon={textCopied ? <Check /> : <Copy03 />}
      onClick={(e) => {
        // Prevent to redirect to the detail page.
        e.preventDefault();
        e.stopPropagation();
        void navigator.clipboard.writeText(textCopy);
        setTextCopied(true);
      }}
      className="cursor-copy"
    >
      {textCopied ? t("PeopleFinder.copied") : children}
    </Pill>
  );
};
